import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalAddTopicComponent } from '../../e-learning-management/modal-add-topic/modal-add-topic.component';

@Component({
  selector: 'app-modal-payment-report',
  templateUrl: './modal-payment-report.component.html',
  styleUrls: ['./modal-payment-report.component.scss']
})
export class ModalPaymentReportComponent implements OnInit {

  modalData: any;
  type: string;

  date = new Date();
  firstDay;
  lastDay;
  paymentDateForm;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddTopicComponent>,
    private fb: FormBuilder
  ) {
    this.modalData = data;
    this.type = data.type;
  }

  ngOnInit(): void {
    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
    // console.log(this.firstDay, this.lastDay);

    this.paymentDateForm = this.fb.group({
      paymentDate: [[this.firstDay, this.lastDay], Validators.required]
    });

  }

  confirm() {

    let response;

    // let start = this.paymentDateForm.value.paymentDate[0];
    // let end = this.paymentDateForm.value.paymentDate[1]

    response = {
      status: true,
      value: {
        startDate: this.paymentDateForm.value.paymentDate[0],
        endDate: this.paymentDateForm.value.paymentDate[1]
      }
    }
    this.dialogRef.close(response);
  }


  closeModal() {
    const response = {
      status: false
    }
    // // console.log(response);
    this.dialogRef.close(response);
  }
}


